export default "__VITE_ASSET__E3kD$3Cz__"